const homeCampaignsData = [
	{
		campaignThumbnail: require('./marketplace.png'),
		title: 'Hire people with top skills',
		btnText: 'Continue',
		btnLink: 'https://www.69work.com/marketplace',
	},
	{
		campaignThumbnail: require('./hosting.png'),
		title: 'Fully-managed web hosting',
		btnText: 'Continue',
		btnLink: 'https://cloud.69work.com',
	},
];

export default homeCampaignsData;
